export default __webpack_public_path__ + "static/AmericanaStd-Bold-945fe3469b68c754fc546455a8f7efa5.woff2";